import { Controller } from "@hotwired/stimulus"

// Empties the elements matching `selector` when the field changes.
export default class extends Controller {
  static values = { selector: String }

  clear() {
    document.querySelectorAll(this.selectorValue).forEach((element) => element.replaceChildren())
  }
}
